<script>
import { pageTitleMixin } from '@ubic/vue-mixins';
import { getRandomString } from '@/utils';
import { permissions as permissionsEnum, permissionTitles } from '@/constants';
import FormError from '@/components/FormError';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import service from './service';

export default {
  pageTitle: 'Новый администратор',
  mixins: [pageTitleMixin],
  data () {
    return {
      username: '',
      isBot: false,
      password: '',
      permissions: [],
      isSaving: false,
      error: '',
    };
  },
  computed: {
    hasWritePermission () {
      return this.$store
        .getters['auth/checkPermission'](permissionsEnum.ADMIN_WRITE);
    },
  },
  methods: {
    handleUsernameInput (value) {
      this.username = value;
    },
    handleIsBotChange (value) {
      this.isBot = value;
    },
    handlePasswordInput (value) {
      this.password = value;
    },
    handleGeneratePassword () {
      this.password = getRandomString() + getRandomString();
    },
    handlePermissionsInput (values) {
      this.permissions = values;
    },
    async handleSubmit (e) {
      e.preventDefault();

      if (this.isSaving) {
        return;
      }

      this.isSaving = true;
      this.error = '';

      try {
        const { username, isBot, permissions } = this;
        const password = isBot
          ? getRandomString() + getRandomString()
          : this.password;

        await service.create({ username, isBot, password, permissions });

        this.emitDataUpdate();
        this.handleClose();
      } catch (err) {
        this.error = 'Ошибка при создании пользователя';
        this.isSaving = false;
      }
    },

    handleClose () {
      this.$emit('close');
      this.$router.replace('/admins');
    },
    emitDataUpdate () {
      this.$emit('dataupdate');
    },
  },
  render () {
    if (!this.hasWritePermission) {
      return (
        <u-modal onClose={this.handleClose}>
          <ErrorAccessDenied />
        </u-modal>
      );
    }

    const {
      $style,
      username,
      isBot,
      password,
      permissions,
      isSaving,
      error,
      handlePermissionsInput,
    } = this;

    return (
      <u-modal onClose={this.handleClose}>
        <u-title
          slot="header"
          level="2"
        >
          Новый администратор
        </u-title>

        <form
          action="#"
          method="post"
          onSubmit={this.handleSubmit}
        >
          <div class="form-field">
            <div class="form-field__label">
              <label for="usernameInput">
                Логин
              </label>
            </div>
            <u-input
              id="usernameInput"
              name="username"
              required
              value={username}
              onInput={this.handleUsernameInput}
            />
          </div>
          <div class="form-field">
            <u-checkbox
              name="isBot"
              value="isBot"
              checked={isBot}
              onChange={this.handleIsBotChange}
            >
              является ботом
            </u-checkbox>
          </div>
          {!isBot && (
            <div class="form-field">
              <div class="form-field__label">
                <label for="passwordInput">
                  Пароль
                </label>
              </div>
              <span>
                <u-input
                  id="passwordInput"
                  name="password"
                  required
                  value={password}
                  onInput={this.handlePasswordInput}
                />

                <button
                  class={$style.inputButton}
                  type="button"
                  onClick={this.handleGeneratePassword}
                >
                  сгенерировать
                </button>
              </span>
            </div>
          )}
          <div class="form-field">
            <div class="form-field__label">
              Доступ к разделам
            </div>
            <div>
              {Object
                .values(permissionsEnum)
                .map(permission => (
                  <div
                    key={permission}
                    class={$style.checkbox}
                  >
                    <u-checkbox
                      name="permissions"
                      value={permission}
                      checked={permissions}
                      onChange={handlePermissionsInput}
                    >
                      {permissionTitles[permission]}
                    </u-checkbox>
                  </div>
                ))}
            </div>
          </div>
          {Boolean(error) && (
            <FormError>
              {error}
            </FormError>
          )}
          <div class="form-footer">
            <u-btn
              type="submit"
              size="wide"
            >
              {isSaving ? (
                <u-spinner inline />
              ) : 'Создать'}
            </u-btn>
          </div>
        </form>
      </u-modal>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.inputButton {
  @include button-reset();

  color: $color-primary;
  font-size: .75em;
  margin-left: 1em;

  &:hover,
  &:focus {
    color: $color-primary-lighter;
  }
}

.checkbox {
  & + & {
    margin-top: .5em;
  }
}
</style>
